(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iman-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('iman-mega-menu')) {
    customElements.define('iman-mega-menu', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.desktop = matchMedia('(min-width: 990px)');
        this.pointer = matchMedia('(hover: hover) and (pointer: fine)');
        this.toggle = this.querySelector('.iman-mega__toggle');
        this.disclosures = [...this.querySelectorAll('.iman-mega__disclosure')];
        this.classList.add('is-ready');
        this.toggle.addEventListener('click', () => this.setMobile(!this.classList.contains('is-mobile-open')), options);
        this.querySelector('.iman-mega__close').addEventListener('click', () => { this.closeAll(); this.toggle.focus(); }, options);
        this.querySelector('.iman-mega__backdrop').addEventListener('click', () => this.closeAll(), options);
        this.disclosures.forEach(details => {
          const summary = details.querySelector('summary');
          details.addEventListener('pointerenter', () => {
            clearTimeout(this.leaveTimer);
            if (this.desktop.matches && this.pointer.matches) this.open(details);
          }, options);
          details.addEventListener('pointerleave', () => {
            if (this.desktop.matches && this.pointer.matches) this.leaveTimer = setTimeout(() => {
              if (!details.contains(document.activeElement)) { details.open = false; this.sync(); }
            }, 160);
          }, options);
          details.addEventListener('toggle', () => {
            if (details.open) this.disclosures.forEach(other => { if (other !== details) other.open = false; });
            this.sync();
          }, options);
          summary.addEventListener('keydown', event => {
            if (event.key !== 'ArrowDown') return;
            event.preventDefault();
            this.open(details);
            details.querySelector('.iman-mega__panel a')?.focus();
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const active = this.disclosures.find(details => details.open);
          const mobileOpen = this.classList.contains('is-mobile-open');
          if (!active && !mobileOpen) return;
          event.preventDefault();
          this.closeAll();
          if (mobileOpen) this.toggle.focus();
          else active.querySelector('summary').focus();
        }, options);
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll();
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.closeAll();
        }, options);
        this.desktop.addEventListener('change', () => this.closeAll(), options);
      }
      open(details) {
        clearTimeout(this.leaveTimer);
        this.disclosures.forEach(other => { if (other !== details) other.open = false; });
        details.open = true;
        this.sync();
      }
      sync() {
        this.classList.toggle('has-panel', this.disclosures.some(details => details.open));
      }
      setMobile(open) {
        this.classList.toggle('is-mobile-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (!open) this.disclosures.forEach(details => { details.open = false; });
        this.sync();
      }
      closeAll() {
        clearTimeout(this.leaveTimer);
        this.setMobile(false);
      }
      disconnectedCallback() {
        clearTimeout(this.leaveTimer);
        this.events?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
